import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from './ui/button';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';
import { useCart } from '../context/CartContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ShopSuccess = () => {
  const navigate = useNavigate();
  const { clear } = useCart();
  const [state, setState] = useState('checking'); // checking | paid | failed
  const [order, setOrder] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');
    if (!sessionId) {
      setState('failed');
      return;
    }

    let attempts = 0;
    const maxAttempts = 6;

    const poll = async () => {
      try {
        const res = await axios.get(`${API}/checkout/status/${sessionId}`);
        if (res.data.payment_status === 'paid') {
          setOrder(res.data);
          setState('paid');
          clear();
          return;
        }
        if (res.data.status === 'expired') {
          setState('failed');
          return;
        }
        if (attempts >= maxAttempts) {
          setState('failed');
          return;
        }
        attempts += 1;
        setTimeout(poll, 2000);
      } catch {
        setState('failed');
      }
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center" data-testid="shop-success-page">
        {state === 'checking' && (
          <>
            <Loader2 className="w-12 h-12 text-gold animate-spin mx-auto mb-4" />
            <h1 className="text-2xl font-bold">Confirming your payment…</h1>
            <p className="text-white/60 mt-2">Please wait a moment.</p>
          </>
        )}
        {state === 'paid' && (
          <>
            <CheckCircle2 className="w-16 h-16 text-green-400 mx-auto mb-4" />
            <h1 className="text-3xl font-bold">Thank you!</h1>
            <p className="text-white/70 mt-2">
              Your order is confirmed. We'll get it shipped out to you soon.
            </p>
            {order?.items && (
              <div className="bg-white/5 border border-white/10 rounded-lg p-4 mt-6 text-left">
                {order.items.map((it, idx) => (
                  <div key={idx} className="flex justify-between text-sm py-1 text-white/80">
                    <span>{it.name} × {it.quantity}</span>
                    <span>${(it.price * it.quantity).toFixed(2)}</span>
                  </div>
                ))}
              </div>
            )}
            <Button onClick={() => navigate('/')} className="bg-gold text-black hover:bg-gold/90 font-semibold mt-8" data-testid="success-home-button">
              Back to Home
            </Button>
          </>
        )}
        {state === 'failed' && (
          <>
            <XCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
            <h1 className="text-2xl font-bold">Payment not completed</h1>
            <p className="text-white/70 mt-2">
              We couldn't confirm your payment. If you were charged, please contact us at Old2newhb@gmail.com.
            </p>
            <Button onClick={() => navigate('/#shop')} className="bg-gold text-black hover:bg-gold/90 font-semibold mt-8" data-testid="success-retry-button">
              Back to Shop
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default ShopSuccess;
